<template>
  <div>
    <collapse :multiple-active="false" :active-index="-1">
     
      <collapse-form-item
        id="ReplacementReceiptQuantityStep"
        title="Verify Replacement Receipt Quantities"
        @tabOpen="loadItem"
        :status="replacementItemReceiptStatus"
        v-bind:tabChange="getAllState.replacement"
        name="1"
      >
        <div>
          <replacement-receipt
            :is-read-only="isReadOnly"
            ref="ReplacementReceiptQuantityStep"
            @validated="onSubStepValidated"
          ></replacement-receipt>
        </div>
      </collapse-form-item>
      
      <collapse-form-item
        id="ReturnReplacementReceiptAcknowledgmentStep"
        title="Return / Replacement Receipt Acknowledgment (Signature)"
        @tabOpen="loadItem"
        :status="returnReplacementReceiptAcknowledgmentStatus"
        v-bind:tabChange="getAllState.replacement"
        name="4"
      >
        <div>
          <return-replacement-receipt-acknowledgment
            :is-read-only="isReadOnly"
            v-on:show-document-tab="showDocumentTab"
            ref="ReturnReplacementReceiptAcknowledgmentStep"
            @validated="onSubStepValidated"
          ></return-replacement-receipt-acknowledgment>
        </div>
      </collapse-form-item>
    </collapse>
  </div>
</template>

<script>
import ReplacementReceipt from "@/components/App/order/replacement/replacementreceiptquantity/ReplacementReceipt.vue";
import ReturnReplacementReceiptAcknowledgment from "@/components/App/order/replacement/ReturnReplacementReceiptAcknowledgment.vue";
import { Select, Option } from "element-ui";
import { BaseRadio, Collapse, CollapseFormItem } from "@/components/index";
import { mapGetters, mapActions } from "vuex";

export default {
  props: ["isReadOnly"],
  name: "Receipt",
  components: {
    ReplacementReceipt,
    ReturnReplacementReceiptAcknowledgment,
    Collapse,
    CollapseFormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio
  },

  data() {
    return {
      status: null,
      loadSignature: false,
    };
  },
  mounted() {
    this.getReplacementItemReceiptStatus(this.$route.params.id);
    this.getReturnReplacementReceiptAcknowledgmentStatus(this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      replacementItemReceiptStatus: "replacementItemReceipt/replacementItemReceiptStatus",
      returnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgmentStatus",
      orderStatus: "orderMetadata/orderStatus",
      getAllState: "moduleState/getAllStates"
    }),
  },
  methods: {
    ...mapActions({
      getReplacementItemReceiptStatus: "replacementItemReceipt/getReplacementItemReceiptStatus",
      getReturnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgmentStatus",
      submitReceiving: "orderMetadata/submitReceiving",
    }),
    onSubStepValidated(validated, model) {
      this.$emit("on-validated", validated, model);
    },
    loadItem(ref, isOpend) {
      switch (ref) {
        case "ReplacementReceiptQuantityStep":
          this.getReplacementItemReceiptStatus(this.$route.params.id);
          break;
        case "ReturnReplacementReceiptAcknowledgmentStep":
           this.getReturnReplacementReceiptAcknowledgmentStatus(this.$route.params.id);
          break;
        default:
          break;
      }
      if(isOpend)
        return this.$refs[ref].loaded();
      else
        return;
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
    },
  },
};
</script>

<style scoped>
@import "../../../styles/custom_grid.css";

.card-collapse .card.card-plain.has-danger .card-header:after {
  background: #ec250d;
}

.card-collapse .card.card-plain.has-success .card-header:after {
  background: #10b45a;
}
</style>
